import {
  BLOCK,
  BONUS_LEAVE,
  CONFIG_FROM_DEFAULT_HRMS,
  DATE_FORMAT_FULL,
  DATE_FORMAT_HM,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  EDIT_TYPE,
  GENERAL_CONFIGURATION,
  HISTORY_TYPE,
  LEAVE_CARRYOVER_SCREEN,
  NUMBER_TYPE,
  POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
  PROJECT_LEAVE_DETAIL_SCREEN,
  REMOVE_TYPE,
  RESPONSE_TYPE_ERROR,
  RESPONSE_TYPE_SUCCESS,
  STRING_TYPE,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
} from "@/utils";
import moment from "moment";
import { uuid } from "uuidv4";
import Vue from "vue";
export const convertObjectToParams = (filters) => {
  let params = "";
  if (filters)
    Object.keys(filters).map((it) => {
      let val = filters[it];
      if (Array.isArray(val)) {
        if (val.length > 0) {
          if (params.indexOf("?") > -1) {
            params += `&${it}=${val}`;
          } else {
            params += `?${it}=${val}`;
          }
        }
      } else if (val || val === false) {
        if (params.indexOf("?") > -1) {
          params += `&${it}=${val}`;
        } else {
          params += `?${it}=${val}`;
        }
      }
      return params;
    });
  return params;
};

export const downloadFile = (data, fileName, type) => {
  var fileURL = URL.createObjectURL(
    new Blob([data], {
      type: type ?? "application/vnd.ms-excel",
    })
  );
  var fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", fileName);
  document.body.appendChild(fileLink);
  fileLink.click();
};

export const getUnique = (arr, comp) => {
  if (arr) {
    const unique = arr
      .map((e) => e[comp])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }
};

export const scaleScreen = () => {
  let content = `width=device-width,initial-scale=0.45`;
  if (document.body.clientWidth <= 768) {
    document.querySelector('meta[name="viewport"]').setAttribute("content", content);
  }
};

export const getMessages = (message) => {
  let messages = [];
  if (message && Array.isArray(message)) {
    message.forEach((msg) => messages.push(msg));
  } else {
    messages.push(message);
  }
  return messages;
};

export const checkShowWithLastTimesheet = (date, lastTimesheet, timeline, formatDate) => {
  if (date && lastTimesheet.last_timesheet_period_end_date) {
    // const currentDate = moment("2022-08-26 10:01:00", DATE_FORMAT_FULL);
    const currentDate = moment(new Date());
    const dateCompare = moment(lastTimesheet.last_timesheet_period_end_date, DATE_FORMAT_SHORT).add({
      days: 1,
      hours: timeline ? timeline : 0,
    });
    if (currentDate.isAfter(dateCompare)) {
      return moment(date, formatDate ? formatDate : DATE_FORMAT_FULL).isAfter(
        moment(lastTimesheet.last_timesheet_period_end_date, DATE_FORMAT_SHORT).endOf("day")
      );
    } else {
      return moment(date, formatDate ? formatDate : DATE_FORMAT_FULL).isAfter(
        moment(lastTimesheet.last_timesheet_period_end_date, DATE_FORMAT_SHORT).subtract(1, "months")
      );
    }
  } else {
    return true;
  }
};

export const disableWeekendCommon = (date, lastTimesheet, timeline, formatDate) => {
  return !checkShowWithLastTimesheet(date, lastTimesheet, timeline, formatDate);
};

export const getInfoStaff = (staff) => {
  if (staff) {
    const fullName = staff?.name;
    let departmentNameEn = "";
    if (staff.department_name) {
      departmentNameEn = staff.department_name?.name ?? "";
    } else {
      departmentNameEn = staff?.departmentName ?? "";
    }

    if (fullName && departmentNameEn) {
      return `${fullName} - ${departmentNameEn}`;
    } else if (fullName && !departmentNameEn) {
      return fullName;
    } else return "";
  }
  return "";
};
export const getInfoStaffFull = (staff) => {
  if (!staff) return "";
  const infoStaff = getInfoStaff(staff);
  if (!infoStaff) return "";
  return `${infoStaff} (${staff?.user_name ?? ""})`;
};

export const beforeUploadFile = (file) => {
  const exc = ["pdf", "txt", "csv", "mp4", "jpg", "jpeg", "docx", "xlsx", "png", "pptx"];
  if (exc.indexOf(file.name.split(".").pop()?.toLowerCase()) === -1) {
    return { isValid: false, message: "File is wrong format" };
  }
  // check size file > 5MB
  if (file.size > 5242880) {
    return { isValid: false, message: `File <= 5MB` };
  }
  return { isValid: true };
};

export const validateFile = (file, acceptType, acceptSize = 5) => {
  if (!acceptType || acceptType?.length <= 0) return { isValid: true };

  if (!acceptType.includes(`.${file.name.split(".").pop()?.toLowerCase()}`)) {
    return { isValid: false, message: "File is wrong format" };
  }
  // check size file > 5MB
  if (file.size > acceptSize * Math.pow(1024, 2)) {
    return { isValid: false, message: `File <= ${acceptSize}MB` };
  }
  return { isValid: true };
};

export const getData = (data) => {
  if (data) {
    return data;
  }
  return "-";
};

export const formatDateToString = (date, formatTo = DATE_FORMAT_V2, formatFrom = DATE_FORMAT_FULL) => {
  if (!date) return "";
  const stringToDate = moment(date, formatFrom);
  return stringToDate.isValid() ? stringToDate.format(formatTo) : "";
};

export const formatStringToDate = (dateString, formatDate = DATE_FORMAT_V2) => {
  if (!dateString) return null;
  const stringToDate = moment(dateString, formatDate);
  return stringToDate.isValid() ? stringToDate : null;
};

export const getHoursWorkingDay = (workingTime, block = BLOCK) => {
  if (!workingTime) return [];
  const workingTimeParse = parseFloat(workingTime);
  if (workingTimeParse) {
    const hourTrunc = Math.trunc(workingTimeParse);
    const remainHours = workingTimeParse % 1;
    const remainMinutes = remainHours * 60;
    let minutes = getMinutesWorkingDay(60, block);
    const hours = Array.from(Array(hourTrunc + 1).keys());
    const res = hours.reduce((result, hour) => {
      if (hour === hourTrunc) {
        let minutesFinal = getMinutesWorkingDay(remainMinutes, block, true, false);
        result.push({
          key: uuid(),
          value: hour,
          label: `${hour} hour(s)`,
          children: minutesFinal?.map((minute) => ({
            key: minute,
            value: minute,
            label: `${minute} minute(s)`,
          })),
        });
      } else if (hour === 0) {
        let minutesFirst = getMinutesWorkingDay(60, block, false, true);
        result.push({
          key: uuid(),
          value: hour,
          label: `${hour} hour(s)`,
          children: minutesFirst?.map((minute) => ({
            key: minute,
            value: minute,
            label: `${minute} minute(s)`,
          })),
        });
      } else {
        result.push({
          key: uuid(),
          value: hour,
          label: `${hour} hour(s)`,
          children: minutes?.map((minute) => ({
            key: minute,
            value: minute,
            label: `${minute} minute(s)`,
          })),
        });
      }
      return result;
    }, []);
    return res;
  } else return [];
};
export const getMinutesWorkingDay = (remainMinutes, block, isFinal = false, isFirst = false) => {
  if (remainMinutes === 0) return [0];
  let minutes = [];
  if (isFinal) {
    for (let i = 0; i < remainMinutes; i += block) {
      minutes.push(i);
      if (remainMinutes - i < block && i !== remainMinutes) {
        minutes.push(remainMinutes);
      }
    }
  } else if (isFirst) {
    for (let i = block; i < remainMinutes; i += block) {
      minutes.push(i);
      if (remainMinutes - i < block && i !== remainMinutes) {
        minutes.push(remainMinutes);
      }
    }
  } else {
    for (let i = 0; i < 60; i += block) {
      minutes.push(i);
    }
  }
  return minutes;
};

export const isNumeric = (str) => {
  // if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && !isNaN(parseFloat(str)) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  ); // ...and ensure strings of whitespace fail
};

export const isInteger = (value) => {
  return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
};

export const countDecimals = (value) => {
  if (Math.floor(value) === value) return 0;
  return value.toString().split(".")[1].length || 0;
};

export const handleActionByScreen = (
  screen,
  record,
  userInfo,
  actions,
  timeServer = moment(new Date()),
  mostRecentTimeSheetApproved
) => {
  const { roles } = userInfo;
  const { expireDate, applyDate, usedHours, used, apply_date, expire_date, is_from } = record;
  const actionsResult = [];
  switch (screen) {
    case LEAVE_CARRYOVER_SCREEN: {
      const checkRoles = roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
      actions?.map((action) => {
        const { key } = action;
        switch (key) {
          case EDIT_TYPE:
            {
              if (
                checkRoles &&
                moment(expireDate, DATE_FORMAT_V2_FULL).isSameOrAfter(
                  moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
                )
              ) {
                actionsResult.push(action);
              }
            }
            break;
          case REMOVE_TYPE: {
            if (
              checkRoles &&
              !(
                usedHours > 0 ||
                moment(expireDate, DATE_FORMAT_V2_FULL).isBefore(moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day"))
              )
            ) {
              actionsResult.push(action);
            }
            break;
          }
          case HISTORY_TYPE: {
            if (checkRoles) {
              actionsResult.push(action);
            }
            break;
          }
          default:
            break;
        }
      });
      break;
    }
    case BONUS_LEAVE: {
      const checkRoles = roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
      actions?.map((action) => {
        const { key } = action;
        switch (key) {
          case EDIT_TYPE: {
            if (
              moment(record.expireDate, DATE_FORMAT_V2_FULL).isSameOrAfter(
                moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
              ) &&
              checkRoles
            ) {
              actionsResult.push(action);
            }
            break;
          }

          case REMOVE_TYPE: {
            const inValidExpiredDate = moment(record.expireDate, DATE_FORMAT_V2_FULL).isBefore(
              moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
            );
            if (record.used == 0 && !inValidExpiredDate && checkRoles) {
              actionsResult.push(action);
            }
            break;
          }
          case HISTORY_TYPE: {
            if (checkRoles) {
              actionsResult.push(action);
            }
            break;
          }
          default:
            actionsResult.push(action);
            break;
        }
      });
      break;
    }
    case PROJECT_LEAVE_DETAIL_SCREEN: {
      const checkRoles = roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
      actions?.map((action) => {
        const { key } = action;
        switch (key) {
          case EDIT_TYPE:
            {
              if (
                checkRoles &&
                moment(expireDate, DATE_FORMAT_V2_FULL).isSameOrAfter(
                  moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
                )
              ) {
                actionsResult.push(action);
              }
            }
            break;
          case REMOVE_TYPE: {
            if (
              checkRoles &&
              !(
                used > 0 ||
                moment(expireDate, DATE_FORMAT_V2_FULL).isBefore(moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day"))
              )
            ) {
              actionsResult.push(action);
            }
            break;
          }
          case HISTORY_TYPE: {
            if (checkRoles) {
              actionsResult.push(action);
            }
            break;
          }
        }
      });
      break;
    }
    case GENERAL_CONFIGURATION: {
      const checkRoles = roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
      actions?.map((action) => {
        const { key } = action;
        switch (key) {
          case EDIT_TYPE: {
            if (
              moment(expireDate, DATE_FORMAT_V2_FULL).isSameOrAfter(
                moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
              ) &&
              checkRoles
            ) {
              actionsResult.push(action);
            }
            break;
          }

          case REMOVE_TYPE: {
            if (
              moment(applyDate, DATE_FORMAT_V2_FULL).isSameOrAfter(moment(timeServer, DATE_FORMAT_V2_FULL)) &&
              checkRoles
            ) {
              actionsResult.push(action);
            }
            break;
          }
          case HISTORY_TYPE: {
            if (checkRoles) {
              actionsResult.push(action);
            }
            break;
          }
          default:
            actionsResult.push(action);
            break;
        }
      });
      break;
    }
    case POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN: {
      if (is_from !== CONFIG_FROM_DEFAULT_HRMS) {
        const checkRoles = roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
        actions?.forEach((action) => {
          const { key } = action;
          switch (key) {
            case EDIT_TYPE:
              {
                if (
                  checkRoles &&
                  moment(expire_date, DATE_FORMAT_V2_FULL).isSameOrAfter(
                    moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
                  )
                ) {
                  actionsResult.push(action);
                }
              }
              break;
            case REMOVE_TYPE: {
              if (
                checkRoles &&
                moment(expire_date, DATE_FORMAT_V2_FULL).isSameOrAfter(
                  moment(timeServer, DATE_FORMAT_V2_FULL).startOf("day")
                ) &&
                moment(mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL).isBefore(
                  moment(apply_date, DATE_FORMAT_V2_FULL)
                )
              ) {
                actionsResult.push(action);
              }
              break;
            }
            case HISTORY_TYPE: {
              if (checkRoles) {
                actionsResult.push(action);
              }
              break;
            }
          }
        });
      }
      break;
    }
    default: {
      actionsResult.push(...actions);
    }
  }
  return actionsResult;
};

export const formatDateStringToString = (date, formatTo = DATE_FORMAT_V2, formatFrom = DATE_FORMAT_V2_FULL) => {
  if (!date) return "";
  const stringToDate = moment(date, formatFrom);
  return stringToDate.isValid() ? stringToDate.format(formatTo) : "";
};

export const getMessageResponseType = async (data) => {
  if (data.request.responseType === "blob" && data.response.data instanceof Blob) {
    const errorObject = JSON.parse(await data.response.data.text());
    return errorObject;
  }
  return data.response.data;
};
export const showMessages = (message, messages, type = RESPONSE_TYPE_SUCCESS) => {
  message && typeof message === "string" && Vue.$toast?.[type](message);
  message &&
    typeof message === "object" &&
    message?.forEach((msg) => {
      Vue.$toast?.[type](msg);
    });
  messages && typeof messages === "string" && Vue.$toast?.[type](messages);
  messages &&
    messages?.length > 0 &&
    messages?.forEach((msg) => {
      Vue.$toast?.[type](msg);
    });
};

export const handleMessagesAPI = (res) => {
  const { message, messages, code } = res;
  const responseType = code == 200 ? RESPONSE_TYPE_SUCCESS : RESPONSE_TYPE_ERROR;
  showMessages(message, messages, responseType);
};

export const filterOption = (input, option, isMatchToKeyCount) => {
  let textMatch = option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  let keyMatch = isMatchToKeyCount && option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  return textMatch || keyMatch;
};
export const filterOptionKeyMatch = (input, option) => {
  return filterOption(input, option, true);
};

export const toFixedNumber = (number, digits = 2) => {
  if (!number) return 0;
  return Number(number).toFixed(digits);
};

export const tryParseJSONObject = (jsonString) => {
  try {
    var o = JSON.parse(jsonString);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === "object") {
      return o;
    }
  } catch (e) {
    return false;
  }
};

export const formatExplanationRule = (data) => {
  if (!data) return "";
  const { explanation_number, refund_hours_per_explanation, explanation_time_per_days } = data;
  return `${explanation_number ?? 0} times/ payroll period, ${refund_hours_per_explanation ?? 0} hours/ time, ${
    explanation_time_per_days ?? 0
  } times/ day`;
};

export const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
};

export const isValidHttpUrlRegex = (string) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(string);
};

export const formatDataField = (value, extra, type = NUMBER_TYPE) => {
  if (type === NUMBER_TYPE) {
    return `${value ?? 0} ${extra ?? ""}`;
  } else if (type === STRING_TYPE) {
    return `${value ?? ""} ${value && extra ? extra : ""}`;
  }
};
export const formatDataFieldWithFixed = (value = 0, extra) => {
  return Number.parseFloat(value).toFixed(2) + " " + extra;
};
export const formatWorkTime = (start, end) => {
  return `${formatDateToString(start, DATE_FORMAT_HM)} - ${formatDateToString(end, DATE_FORMAT_HM)}`;
};
